<template>
  <div id="review-setting" class="vs-con-loading__container" v-if="config.gocheckin_feature == 1 || config.pos_feature == 1">
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Review Setting</span>
        </li>
      </ul>
    </div>
    <vs-tabs :color="colorx" class="bg-white" :class="{'has-pos': config.pos_feature == 1, 'has-pos-only': config.pos_feature == 1 && config.gocheckin_feature == 0}" >
      <vs-tab @click="colorx = 'primary'" label="Go check-in message setting" v-if="config.gocheckin_feature == 1">
        <div class="con-tab-ejemplo py-6 px-4">
          <v-survey-review @LoadDataComplete="loadDataComplete"></v-survey-review>
        </div>
      </vs-tab>

      <vs-tab @click="colorx = 'primary'" label="Google reply review setting" v-if="config.gocheckin_feature == 1">
        <div class="con-tab-ejemplo py-6 px-4">
          <v-google-review></v-google-review>
        </div>
      </vs-tab>
      <vs-tab @click="colorx = 'primary'" label="Staff rating" v-if="config.pos_feature == 1">
        <div class="con-tab-ejemplo py-6 px-4">
          <v-staff-rating-setting></v-staff-rating-setting>
        </div>
      </vs-tab>

    </vs-tabs>
  </div>
  <div v-else-if="config.gocheckin_feature == 0 && config.pos_feature == 0">
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
export default {
  // props: {
  //     dataChange: {
  //         type: Object
  //     }
  // },
  data() {
    // if(this.dataChange) {
    //     console.log(this.dataChange);
    // }
    return {
      colorx: "primary",
      items: [
        {
          title: "Home",
          url: "/",
          icon: "HomeIcon"
        },
        {
          title: "Review Setting",
          active: true
        }
      ],
      loaded_data_num: 0,
      isOpenLoading: false
    };
  },
  // watch: {
  //   // loaded_data_num: {
  //   //   immediate: true,
  //   //   handler() {
  //   //     if(this.loaded_data_num >= 1) {
  //   //       this.closeLoading();
  //   //     } else {
  //   //       this.openLoadingInDiv();
  //   //     }
  //   //   }
  //   // },
  //   config: {
  //     immediate: true,
  //     deep: true,
  //     handler() {
  //       // if(this.config && this.config.gocheckin_feature == 0) {
  //       //   this.loaded_data_num = 1;
  //       // }
  //       if(this.config && this.config.gocheckin_feature != 0 && this.config.gocheckin_feature != 1
  //         && this.config.pos_feature != 0 && this.config.pos_feature != 1) {
  //         this.openLoadingInDiv();
  //       } else {
  //         this.closeLoading();
  //       }
  //     }
  //   }
  // },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    loadDataComplete() {
      this.loaded_data_num++;
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    }
  }
};
</script>
